(function () {
  var KLARNA_TRIGGER = "[data-zonveer-klarna-trigger]";

  function loadAfterpayModal() {
    if (!document.querySelector("[data-afterpay-modal]")) {
      return;
    }

    if (document.querySelector('script[src*="js.squarecdn.com/square-marketplace.js"]')) {
      return;
    }

    var script = document.createElement("script");
    script.src = "https://js.squarecdn.com/square-marketplace.js";
    script.async = true;
    document.head.appendChild(script);
  }

  function refreshKlarnaPlacements() {
    if (!window.KlarnaOnsiteService) {
      return;
    }

    window.KlarnaOnsiteService.push({ eventName: "refresh-placements" });
  }

  function findKlarnaAction(root) {
    if (!root) {
      return null;
    }

    var action = root.querySelector('[part~="osm-cta"], button, a[href]');

    if (action) {
      return action;
    }

    var elements = root.querySelectorAll("*");

    for (var index = 0; index < elements.length; index += 1) {
      if (!elements[index].shadowRoot) {
        continue;
      }

      action = findKlarnaAction(elements[index].shadowRoot);

      if (action) {
        return action;
      }
    }

    return null;
  }

  function openKlarna(trigger) {
    var placement = trigger.querySelector("klarna-placement");
    var action = placement && findKlarnaAction(placement.shadowRoot);

    if (!action) {
      return false;
    }

    trigger.dataset.klarnaOpening = "true";
    action.click();

    window.setTimeout(function () {
      delete trigger.dataset.klarnaOpening;
    }, 50);

    return true;
  }

  function requestKlarnaOpen(trigger) {
    var attempts = 0;

    if (openKlarna(trigger)) {
      return;
    }

    refreshKlarnaPlacements();

    var timer = window.setInterval(function () {
      attempts += 1;

      if (openKlarna(trigger) || attempts >= 40) {
        window.clearInterval(timer);
      }
    }, 100);
  }

  document.addEventListener("click", function (event) {
    var trigger = event.target.closest && event.target.closest(KLARNA_TRIGGER);

    if (!trigger || trigger.dataset.klarnaOpening === "true") {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    requestKlarnaOpen(trigger);
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Enter" && event.key !== " ") {
      return;
    }

    var trigger = event.target.closest && event.target.closest(KLARNA_TRIGGER);

    if (!trigger) {
      return;
    }

    event.preventDefault();
    requestKlarnaOpen(trigger);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      loadAfterpayModal();
      refreshKlarnaPlacements();
    }, { once: true });
  } else {
    loadAfterpayModal();
    refreshKlarnaPlacements();
  }

  document.addEventListener("shopify:section:load", function () {
    loadAfterpayModal();
    refreshKlarnaPlacements();
  });
})();
